import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classes from './ScheduleModalHeader.module.scss';

const getTitle = (editingSchedule, addModal) => {
  if (addModal) {
    return (
      <FormattedMessage
        id="components.schedule.addTitle"
        defaultMessage="Add Meeting"
      />);
  }

  if (editingSchedule) {
    return (
      <FormattedMessage
        id="components.schedule.editTitle"
        defaultMessage="Edit Meeting Details"
      />
    );
  }

  return (
    <FormattedMessage
      id="components.schedule.title"
      defaultMessage="Schedule a Meeting"
    />
  );
};

const getInstructions = (editingSchedule, addModal) => {
  if (!!addModal) {
    return (
      <FormattedMessage
        id="components.schedule.addInstructions"
        defaultMessage="Add Lifesize meeting details to your invitation."
      />);
  }

  if (!!editingSchedule) {
    return (
      <FormattedMessage
        id="components.schedule.editInstructions"
        defaultMessage="Edit the Lifesize meeting details for your invitation."
      />
    );
  }

  return (
    <FormattedMessage
      id="components.schedule.inviteInstructions"
      defaultMessage="Invite participants to join you on Lifesize."
    />
  );
};

const ScheduleModalHeader = (props) => {
  const { editingSchedule, addModal } = props;
  return (
    <header className={classes.header}>
      <h1>
        {getTitle(editingSchedule, addModal)}
      </h1>
      <h6>
        {getInstructions(editingSchedule, addModal)}
      </h6>
    </header>
  );
};

ScheduleModalHeader.propTypes = {
  editingSchedule: PT.bool,
  addModal: PT.bool
};

export default ScheduleModalHeader;
